import React, { useEffect, useState } from 'react';

// custom components
import JobCard from '../job-card';

// redux
import { useSelector } from 'react-redux';
import { selectHasTaskId, selectRampMarshallFlightIds } from '_redux/slices/timeline/timeline-bookings';
import { selectThirtyMinLayout } from "_redux/slices/timeline/timeline-control";
import { selectSelectedTask, selectSelectedTasksList, selectSelectedMultiplePAXTask } from "_redux/slices/timeline/selected-task";
import { selectUsedTheme } from '_redux/slices/timeline/theme';

const MarshallTask = (props) => {

    const [id, setId] = useState(null);

    // check if marshall task has been placed before rendering
    const placedOnTimeline = useSelector(selectHasTaskId(id));
    const rampMarshallFlightIds = useSelector(selectRampMarshallFlightIds);
    const thirtyMinLayout = useSelector(selectThirtyMinLayout);


    // OPTIMIZED: Get these once and pass to JobCard to reduce Redux subscriptions
    const selectedTask = useSelector(selectSelectedTask);
    const selectedTasksList = useSelector(selectSelectedTasksList);
    const usedTheme = useSelector(selectUsedTheme);
    const selectedMultiplePAXTask = useSelector(selectSelectedMultiplePAXTask);

    const paxList = Array.isFullArray(props?.flightData?.rampPassengers) ? props?.flightData?.rampPassengers : props?.paxList || [];

    useEffect(() => {
        setId(props?.flightKey + '-marshall-task');
    }, [props])

    if (placedOnTimeline) return null;
    if (!Array.isFullArray(paxList)) return null;
    // check if pax has WCHS and WCHC
    const hasWCHSorWCHC = paxList?.some(pax => {
        const assistanceArray = pax?.assistance || [];
        return assistanceArray?.some(code =>
            code && (code?.includes('WCHS') || code?.includes('WCHC'))
        );
    });

    if (!hasWCHSorWCHC) return null;

    if (rampMarshallFlightIds?.includes(props?.flightData?.flightId)) return null;
    return (
        <JobCard
            showFullCard={true}
            key={id}
            job={
                {
                    _id: id,
                    jobType: props?.type === 'departure' ? 'boarding-task' : 'ramp-task',
                    description: 'Marshall Task for flight ' + props.flightKey,
                    flightKey: props.flightKey,
                    flightNumber: props?.flightData?.flightNumber,
                    flightData: props.flightData,
                    // Marshall tasks are built from the flight document directly (no per-passenger
                    // booking doc), so flightConfirmationDetails must be derived here rather than
                    // left unset - job-confirmation.js falls back to this when the flight document
                    // hasn't (re)loaded yet, and Marshall tasks have no other fallback field.
                    flightConfirmationDetails: {
                        origin: props?.flightData?.origin ?? props?.flightData?.departureAirport ?? null,
                        destination: props?.flightData?.destination ?? props?.flightData?.arrivalAirport ?? null,
                        carrierCode: "",
                        flightNumber: props?.flightData?.flightNumber ?? "",
                        departureDate: props?.flightData?.flightDate ?? props?.flightData?.scheduledDate ?? null,
                        departureTime: props?.flightData?.operationTime ?? null,
                        arrivalTime: props?.flightData?.operationTime ?? null,
                    },
                    status: 'pending',
                    createdAt: new Date().toISOString(),
                    passengers: Array.isFullArray(paxList) ? paxList : [],
                    combinedMarshallBooking: true,
                    combinedRampBooking: props?.type === 'departure' ? false : true,
                    combinedBooking: props?.type === 'departure' ? true : false,
                    isBoardingBooking: props?.type === 'departure' ? true : false,
                }
            }
            timelineJobs={true}
            flightData={props.flightData}
            isBoardingFlight={props?.type === 'departure' ? true : false}
            isMarshallTask={true}
            thirtyMinLayout={thirtyMinLayout}
            selectedTask={selectedTask}
            selectedTasksList={selectedTasksList}
            usedTheme={usedTheme}
            selectedMultiplePAXTask={selectedMultiplePAXTask}
        />
    );
};

export default MarshallTask;






